import { AppConfig } from "../../../config/app";
import { NotificationManager } from "react-notifications";

const API_URL = AppConfig.base_url;

const TOKEN = AppConfig.access_token;

export const fetchOrFilterTransactions = async (payload) => {
  const page = payload?.page ?? 1;
  const per_page = payload?.per_page ?? 25;
  const search = payload?.search ?? "";

  const queryParams = new URLSearchParams({
    page: String(page),
    per_page: String(per_page),
    search,
  });

  const response = await fetch(
    `${API_URL}/transactions/0012990735?${queryParams.toString()}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    },
  );

  const data = await response.json();

  if (!response.ok) {
    NotificationManager.error(data?.message || "Failed to fetch transactions");
    throw data;
  }

  return data;
};
